import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageTitle } from '@/hook/usePageTitle.ts';

export const PageTitleUpdater = () => {
  const location = useLocation();
  const pageTitle = usePageTitle();

  useEffect(() => {
    document.title = 'InterMIND' + (pageTitle ? ` - ${pageTitle}` : '');
  }, [location.pathname, pageTitle]);

  return null;
};
